module.exports = __webpack_public_path__ + "img/608.992f7a5a.jpg";